import { render, staticRenderFns } from "./Ftse.vue?vue&type=template&id=04de6a00&"
import script from "./Ftse.vue?vue&type=script&lang=js&"
export * from "./Ftse.vue?vue&type=script&lang=js&"
import style0 from "./Ftse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports